import { ThunkDispatch } from "redux-thunk";

import CreateApiModule from "@/redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import { $CheckUserModuleName } from "./checkUser.types";

const { actions, constants } = CreateApiModule(
    $CheckUserModuleName,
    ({ url }) => url
);

export const clear = actions.clear;

export const load =
    (email: string, force: boolean = false) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) =>
        await dispatch(
            actions.load(
                {
                    path: {
                        url: `/customerservice/${Config.general.basestore}/customers/${email.trim()}`
                    }
                },
                "HEAD",
                force,
                {
                    skipErrors: [404]
                }
            )
        );

export const refetch = actions.refetch;
export const APIStatus = constants;
